module.exports = __webpack_public_path__ + "static/media/quick-export.bf7f773e.gif";